import Typography from '../../Typography';
import { useEffect, useState } from '@wordpress/element';

const elementos = [
  {
    name: 'filled',
    classes: "!font-['Roboto'] !text-text-secundary !font-medium rounded-lg !border-divider",
    labelExterno: false,
  },
  {
    name: 'search',
    classes: "!font-['Roboto'] !text-text-secundary !font-medium !border-divider",
    labelExterno: false,
  },
  {
    name: 'active',
    classes: "!font-['Roboto'] !text-text-secundary !font-medium rounded-lg !border-text-tertiary",
    labelExterno: false,
  },
  { name: 'error', classes: "!font-['Roboto'] !text-text-secundary" },
];

export function InputBase({
  rows,
  textarea = false,
  componentInterno,
  component = 'filled',
  disabled,
  icon,
  className,
  classNameInput,
  label,
  onClick = () => {},
  onMouseLeave = () => {},
  ...params
}) {
  const [element, setElement] = useState(elementos.find(e => e.name == component));

  useEffect(() => {
    setElement(elementos.find(e => e.name == component));
  }, [component]);
  return (
    <div
      className={`${className} w-full grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex`}
      onClick={onClick}
    >
      {label && element?.labelExterno && (
        <Typography component="body1-semibold">{label}</Typography>
      )}

      <div className="relative w-full">
        {icon && (
          <div className="absolute top-2/4 right-3 grid h-5 w-5 -translate-y-2/4 place-items-center">
            {icon}
          </div>
        )}
        {componentInterno}
        {!textarea ? (
          <input
            label={!element?.labelExterno && label}
            {...params}
            disabled={disabled}
            className={`${element?.classes} ${classNameInput} !text-body w-full ${
              onClick && 'cursor-pointer'
            } 
            ${icon && '!pr-9'} border border-solid self-stretch h-11 px-4 py-2.5 !m-0
            ${disabled ? '!bg-neutras-grey-semi-light bg-opacity-70' : '!bg-neutras-white'} `}
            onMouseLeave={onMouseLeave}
          />
        ) : (
          <textarea
            rows={rows}
            label={!element?.labelExterno && label}
            {...params}
            disabled={disabled}
            className={`${element?.classes} ${classNameInput} !text-body w-full ${
              onClick && 'cursor-pointer'
            } 
            ${icon && '!pr-9'} border border-solid self-stretch min-h-11 px-4 py-2.5 !m-0
            ${disabled ? '!bg-neutras-grey-semi-light bg-opacity-70' : '!bg-neutras-white'} `}
          />
        )}
      </div>
    </div>
  );
}
